import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: `${process.env.REACT_APP_API_KEY}`,
  authDomain: `${process.env.REACT_APP_AUTH_DOMAIN}`,
  projectId: `${process.env.REACT_APP_PROJECT_ID}`,
  storageBucket: `${process.env.REACT_APP_STORAGE_BUCKET}`,
  messagingSenderId: `${process.env.REACT_APP_MESSAGING_SENDER_ID}`,
  appId: `${process.env.REACT_APP_APP_ID}`,
  measurementId: `${process.env.REACT_APP_MEASUREMENT_ID}`,
};

const firebaseApp = initializeApp(firebaseConfig);

// declare messaging variable as undefined initially
let messaging: ReturnType<typeof getMessaging> | null = null;

// cek if the browser support push notif and set messaging
const initializeMessaging = async () => {
  const isSupportedBrowser = await isSupported();
  if (isSupportedBrowser) {
    messaging = getMessaging(firebaseApp);
  } else {
    console.log("Firebase is not supported in this browser.");
  }
};

initializeMessaging();

export const requestFCMToken = async (
  vapidKey: string
): Promise<string | null> => {
  try {
    if (!messaging) {
      console.warn(
        "Messaging is not initialized or browser doesn't support it."
      );
      return null;
    }

    const token = await getToken(messaging, { vapidKey });
    if (token) {
      return token;
    } else {
      console.warn(
        "No registration token available. Request permission to generate one."
      );
      return null;
    }
  } catch (error) {
    console.error("An error occurred while retrieving token:", error);
    return null;
  }
};

export const onMessageListener = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (!messaging) {
      reject("Messaging not initialized.");
      return;
    }

    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};
